import { IconHome } from '@tabler/icons-react';
import { NavLink, Tooltip } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useThemedLayoutContext } from '@refinedev/mantine';
import { useTranslation } from '@refinedev/core';

interface DashboardLinkProps {
  isCollapsed: boolean;
  mobileSiderOpen: boolean;
  selectedKey: string;
  commonNavLinkStyles: any;
  commonTooltipProps: any;
}

export const DashboardLink: React.FC<DashboardLinkProps> = ({
  isCollapsed,
  mobileSiderOpen,
  selectedKey,
  commonNavLinkStyles,
  commonTooltipProps,
}) => {
  const { setMobileSiderOpen } = useThemedLayoutContext();
  const { translate } = useTranslation();
  const label = translate('pages:dashboard.label');

  return (
    <Tooltip label={label} {...commonTooltipProps}>
      <NavLink
        key="dashboard"
        label={isCollapsed && !mobileSiderOpen ? null : label}
        leftSection={<IconHome size={20} />}
        to={'/'}
        pl={isCollapsed || mobileSiderOpen ? '0.75rem' : '1.125rem'}
        active={selectedKey === '/'}
        styles={commonNavLinkStyles}
        component={Link}
        onClick={() => {
          if (mobileSiderOpen) {
            setMobileSiderOpen(false);
          }
        }}
      />
    </Tooltip>
  );
};
